// src/components/ui/LawyerNudgeBanner.tsx
import React from 'react';

interface Props {
  category?: string | null;
  onDismiss?: () => void;
  onFindLawyer?: () => void;
}

const CATEGORY_MESSAGES: Record<string, string> = {
  criminal: 'Criminal matters can have life-altering consequences. A public defender or criminal defense attorney can protect your rights.',
  family: 'Family law (divorce, custody) is complex and emotionally charged. An attorney can help protect your interests and your children\'s.',
  immigration: 'Immigration status issues carry serious risks including deportation. An immigration attorney is strongly recommended.',
  safety: 'Situations involving safety or restraining orders are urgent. Contact law enforcement and an attorney immediately.',
  injury: 'Personal injury and malpractice claims have strict time limits. An attorney can assess your case for free.',
  financial: 'Bankruptcy and foreclosure have long-term financial implications. A bankruptcy attorney can explore your options.',
  employment: 'Employment discrimination and wrongful termination claims have filing deadlines. An employment attorney can help.',
  litigation: 'Federal court cases and appeals require professional legal representation.',
  estate: 'Estate disputes and probate can be complex and contentious. An estate attorney can help.',
};

export function LawyerNudgeBanner({ category, onDismiss, onFindLawyer }: Props) {
  const message = (category && CATEGORY_MESSAGES[category]) ??
    'This situation may benefit from professional legal counsel. A qualified attorney can give you advice specific to your circumstances.';

  return (
    <div className="my-3 rounded-lg border border-amber-300 bg-amber-50 p-3 flex gap-3">
      <span className="text-amber-500 text-lg flex-shrink-0">⚠️</span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-amber-800">Consider speaking with a real lawyer</p>
        <p className="text-xs text-amber-700 mt-0.5">{message}</p>
        <div className="flex gap-2 mt-2">
          {onFindLawyer && (
            <button
              onClick={onFindLawyer}
              className="text-xs bg-amber-600 text-white rounded px-2.5 py-1 hover:bg-amber-700 transition-colors"
            >
              Find a lawyer near me
            </button>
          )}
          <span className="text-xs text-amber-600 self-center">
            This is general info, not legal advice.
          </span>
        </div>
      </div>
      {onDismiss && (
        <button onClick={onDismiss} className="text-amber-400 hover:text-amber-600 text-lg leading-none flex-shrink-0">×</button>
      )}
    </div>
  );
}
